import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import {
  onAddComment,
} from '../../../config/redux/slice/bankUserSlice';
import {
  onAddComment as onAddCommentTransferee,
} from '../../../config/redux/slice/transfereeUserSlice';
import {
  onAddComment as onAddCommentNotap,
} from '../../../config/redux/slice/notapUserSlice';
import {
  clearAll,
  onAddCommentGeneral,
  setErrorMessageUser,
  setLoadingUser,
  showCommentFormFunc
} from '../../../config/redux/slice/appSlice';
import { truncateMiddle } from '../../../helpers/helpers';
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { Spinner } from '../../components';
import { notap_user_roles } from '../../../constants/english';

export default function AddCommentForm() {
    const dispatch = useDispatch()
    const {register, handleSubmit, watch, getValues, setValue, formState: {errors}, reset} = useForm({mode: 'onTouched'})
  
    const {
        userLoading,
        certificateManagement:{certificateDetails}
    } = useSelector((state) => state.app)

    const {
        token,
        userData: {user_role, isAdmin}
    } = useSelector((state) => state.authData)

    const [formData, setFormData] = useState(new FormData());


    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showCommentFormFunc({ modal: false }));
    };

    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        data = {...data, certificate_id: certificateDetails.ID}
        // for (let key in data){  
        //     if(key == "attach_additional_documents"){
        //       if(data[key].length != 0){
        //         formData.append(key, data[key][0])
        //       }
        //     } else{
        //         formData.append(key, data[key])
        //     }
        // }
        const res = await postRequest(
            token,
            `${appApi.addComment}`,
            data,
            dispatch,
            setLoadingUser,
            "",
            setErrorMessageUser,
        )
        if(res != undefined && res.status < 400) {
          dispatch(onAddCommentGeneral())
          if(user_role == 'BANK_USER'){
            dispatch(onAddComment({message: res.data.message}))
          }else if(user_role == 'TRANSFEREE_USER'){
            dispatch(onAddCommentTransferee({message: res.data.message}))
          }else{
            dispatch(onAddCommentNotap({message: res.data.message}))
          }
          dispatch(showCommentFormFunc({ modal: false }));
        }
    }
    function addFileName(e){
      let fileName = e.target.value;
      if(fileName !== ''){
        fileName = fileName.replace(/^.*[\\\/]/, '')
        document.querySelector('.custom-file-label').innerHTML = truncateMiddle(fileName, 30)
      }else{
        document.querySelector('.custom-file-label').innerHTML = "No file Chosen"
      }
    }
  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)} autoComplete={'off'} noValidate>
        <div className="modal-header px-4">
          <h5 className="modal-title" id="exampleModalCenterTitle">Add Comment</h5>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className="modal-body px-4 px-md-7">
        {(isAdmin || notap_user_roles.includes(user_role.toLowerCase())) &&
          <div className="form-group">
                    <label htmlFor='comment_mode'>Select Mode</label>
                    <select 
                      className="form-control rounded-0" 
                      id="comment_mode"
                      {...register("comment_mode", {
                          required: {
                          value: true,
                          message: '*this field is required'
                          }
                      })
                      } 
                    >
                      <option value={''}>Select Mode</option>
                      <option value={'EXTERNAL'}>External</option>
                      <option value={'INTERNAL'}>Internal</option>
                    </select>
                    {
                      errors?.comment_mode?.message &&
                      <div className="text-danger small mt-1">
                          {errors?.comment_mode?.message}
                      </div>
                      }
          </div>
        }

          <div className="form-group">
                <label htmlFor="comment">Comment</label>
                <textarea 
                style={{resize: 'none'}}
                    className="form-control" 
                    id="comment" 
                    rows="3"
                   {...register("comment", {
                    required: {
                    value: true,
                    message: '*this field is required'
                    }
                })
                }
                ></textarea>
                {
                    errors?.comment?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.comment?.message}
                    </div>
                    }
            </div>
        </div>
        <div className="modal-footer px-4 d-flex align-items-center">
          <button disabled={userLoading ? true : false} onClick={()=>{reset()}} type="button" className="btn btn-smoke" data-dismiss="modal">Cancel</button>
          <div>
          {userLoading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary">Add Comment</button>
          }
        </div>
        </div>
      </form>
    </div>
  </div>
</div>
  )
}
